// jQuery Core
window.$ = window.jQuery = require('jquery');

// jQuery Scripts
import fixedHeader from './jquery/fixedHeader';
import productsSlider from './jquery/productsSlider';
import initTextareaAutosize from './jquery/textareaAutoSize';

// Boostrap Core
import 'bootstrap';

// Masonry
var Masonry = require('masonry-layout');

// Angular Core
import angular from 'angular';

// Angular Libraries
import angularNgSanitize from 'angular-sanitize';
import angularNgAnimate from 'angular-animate';
import angularUiBootstrap from 'ui-bootstrap4';
import angularjsToast from './angular/components/angularjsToast.component';

// Angular Controllers
import RegisterController from './angular/controllers/register.controller';
import ErrorsController from './angular/controllers/errors.controller';
import CartItemsTableController from './angular/controllers/cartItemsTable.controller';
import CheckoutController from './angular/controllers/checkout.controller';
import ProductGalleryLargeController from './angular/controllers/productGalleryLarge.controller';
import WatchedProductController from './angular/controllers/watchedProducts.controller';
import SettingsNotificationsController from './angular/controllers/settingsNotifications.controller';
import AttributePreviewImageController from './angular/controllers/attributePreviewImage.controller';

// Angular Services
import TranslateService from './angular/services/translate.service';
import SearchAutocompleteService from './angular/services/searchAutocomplete.service';
import SharedDataService from './angular/services/sharedData.service';
import SpinnerService from './angular/services/spinner.service';

// Angular Components
import Loader from './angular/components/loader.component';
import Add2cart from './angular/components/add2cart.component';
import MiniCart from './angular/components/miniCart.component';
import SearchAutocomplete from './angular/components/searchAutocomplete.component';
import ProductView from './angular/components/productView.component';
import ProductPrice from './angular/components/productPrice.component';
import ProductGallery from './angular/components/productGallery.component';
import Favorite from './angular/components/favorite.component';
import Watch from './angular/components/watch.component';
import CookieWall from './angular/components/cookieWall.component';

// Angular Directives
import SpinnerDirective from './angular/directives/spinner';
import FloatingBoxDirective from './angular/directives/floatingBox';
import AutocompleteDirective from './angular/directives/autocomplete';
import DragHorizontalDirective from './angular/directives/dragHorizontal';
import ConfirmationDirective from './angular/directives/confirmation';
import WatchedDetailsDirective from './angular/directives/watchedDetails';
import NumbersOnlyDirective from './angular/directives/numbersOnly';
import AttributePreviewDirective from './angular/directives/attributePreview';
import MinMaxDirective from './angular/directives/minMax';

// Angular Filters
import TranslateFilter from './angular/filters/translate.filter';

// Angular Dependencies
const dependencies = [
    angularNgSanitize,
    angularNgAnimate,
    angularUiBootstrap,
    angularjsToast
];

// Angular App
const msklepApp = angular.module('msklep', dependencies);

// Angular App Config
msklepApp.config(['$httpProvider', '$animateProvider', function ($httpProvider, $animateProvider) {
    $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    $httpProvider.interceptors.push(function ($q) {
        return {
            'request': function (config) {
                if (config.url.indexOf('api') !== -1) {
                    const currentLocale = document.documentElement.lang;

                    config.url = (currentLocale !== 'pl' ? currentLocale : '') + config.url;
                }

                return config;
            }
        };
    });

    $animateProvider.classNameFilter(/\banimate\b/);
}]);

// Use Angular Resources
msklepApp.controller('CartItemsTableController', CartItemsTableController);
msklepApp.controller('CheckoutController', CheckoutController);
msklepApp.controller('ErrorsController', ErrorsController);
msklepApp.controller('RegisterController', RegisterController);
msklepApp.controller('ProductGalleryLargeController', ProductGalleryLargeController);
msklepApp.controller('WatchedProductsController', WatchedProductController);
msklepApp.controller('SettingsNotificationsController', SettingsNotificationsController);
msklepApp.controller('AttributePreviewImageController', AttributePreviewImageController);

msklepApp.service('translateService', TranslateService);
msklepApp.service('sharedData', SharedDataService);
msklepApp.service('spinnerService', SpinnerService);
msklepApp.service('searchAutocompleteService', SearchAutocompleteService);

msklepApp.component('loader', Loader);
msklepApp.component('add2cart', Add2cart);
msklepApp.component('miniCart', MiniCart);
msklepApp.component('searchAutocomplete', SearchAutocomplete);
msklepApp.component('productView', ProductView);
msklepApp.component('productPrice', ProductPrice);
msklepApp.component('productGallery', ProductGallery);
msklepApp.component('favorite', Favorite);
msklepApp.component('watch', Watch);
msklepApp.component('cookieWall', CookieWall);

require('./angular/directives/floatingBox')(msklepApp);
msklepApp.directive('autocompleteInput', AutocompleteDirective.directiveFactory);
msklepApp.directive('spinner', SpinnerDirective.directiveFactory);
msklepApp.directive('dragHorizontal', DragHorizontalDirective.directiveFactory);
msklepApp.directive('confirmation', ConfirmationDirective.directiveFactory);
msklepApp.directive('watchedDetails', WatchedDetailsDirective.directiveFactory);
msklepApp.directive('numbersOnly', NumbersOnlyDirective.directiveFactory);
msklepApp.directive('attributePreview', AttributePreviewDirective.directiveFactory);
msklepApp.directive('minMax', MinMaxDirective.directiveFactory);

msklepApp.filter('t', TranslateFilter);
msklepApp.filter('fromMap', function() {
    return function(input) {
        var out = {};
        input.forEach((v, k) => out[k] = v);

        return out;
    }
});
msklepApp.filter('trusted', function($sce){
    return function(html){
        return $sce.trustAsHtml(html)
    }
});

// jQuery Scripts loading
$(window).on('load', function () {
    initTextareaAutosize();
});

// jQuery Scripts ready
$(document).ready(function () {
    fixedHeader();
    $('.products-slider').productsSlider();
});

$('body').on('click', '.dropdown-toggle-icon', function(element) {
    if ($(window).width() <= 991) {
        $(this).parent().toggleClass('show-dropdown');
        element.stopPropagation();
        element.preventDefault();
    }
});

let openDropdown = null;

$('body').on('click', '.target-dropdown', function (event) {
    if (openDropdown && openDropdown !== this) {
        $(openDropdown).parent().removeClass('open');
    }

    if ($(window).width() <= 991) {
        return;
    }

    if (openDropdown === this) {
        event.stopPropagation();
        return;
    }

    openDropdown = this;
    $(openDropdown).parent().toggleClass('open');
    event.stopPropagation();
    event.preventDefault();

    let timeout = null;

    if ($(openDropdown).parent().hasClass('open')) {
        $(openDropdown).parent().on('mouseleave', function () {
            timeout = setTimeout(() => {
                $(openDropdown).parent()
                    .removeClass('open')
                    .unbind('mouseleave')
                    .unbind('mouseenter');
                openDropdown = null;
            }, 200);
        });

        $(openDropdown).parent().on('mouseenter', function () {
            clearTimeout(timeout);
        });
    }
});

$('body').on('click', '.dropdown-content', function (event) {
    event.stopPropagation();
});

$('body').click(function() {
    if(openDropdown) {
        $(openDropdown).parent().removeClass('open');
        openDropdown = null;
    }
});

$('body').on('click', '#search-form-mobile', function() {
    $('#search-form-mobile-input').slideToggle();
});

$(window).on('resize', function () {
    if ($(window).width() > 991) {
        $('.show-dropdown').toggleClass('show-dropdown');
    }
});

$('.menu-btn ').on('click', () => {
    $('.header').toggleClass('show-mob-menu');
});

document.addEventListener('DOMContentLoaded', function () {
    let lazyloadImages;

    if ('IntersectionObserver' in window) {
        lazyloadImages = document.querySelectorAll(".lazy");
        let imageObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    let image = entry.target;
                    let imageUrl = image.getAttribute('data-lazy-load');
                    if (imageUrl) {
                        console.log('Lazy loaded background -> ' + imageUrl);
                        image.style.backgroundImage = 'url("' + imageUrl + '")';
                    }
                    image.classList.remove('lazy');
                    imageObserver.unobserve(image);
                }
            });
        });

        lazyloadImages.forEach(function (image) {
            imageObserver.observe(image);
        });
    } else {
        let lazyloadThrottleTimeout;
        lazyloadImages = Array.prototype.slice.call(document.querySelectorAll(".lazy"));

        function lazyload() {
            if (lazyloadThrottleTimeout) {
                clearTimeout(lazyloadThrottleTimeout);
            }

            lazyloadThrottleTimeout = setTimeout(function () {
                let scrollTop = window.pageYOffset;
                lazyloadImages = lazyloadImages.filter(function (img) {
                    if (img.offsetTop < (window.innerHeight + scrollTop)) {
                        let imageUrl = img.getAttribute('data-lazy-load');
                        if (imageUrl) {
                            console.log('Lazy loaded background -> ' + imageUrl);
                            img.style.backgroundImage = 'url("' + imageUrl + '")';
                        }
                        img.src = img.dataset.src;
                        img.classList.remove('lazy');
                        return false;
                    }
                    return true;
                });
                if (lazyloadImages.length === 0) {
                    document.removeEventListener('scroll', lazyload);
                    window.removeEventListener('resize', lazyload);
                    window.removeEventListener('orientationChange', lazyload);
                }
            }, 20);
        }

        document.addEventListener('scroll', lazyload);
        window.addEventListener('resize', lazyload);
        window.addEventListener('orientationChange', lazyload);
        lazyload();
    }
});
